import styled from "styled-components";


export const Container = styled.div`
    max-height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    background-color: #343493;
    color: #fff;
    text-align: center;
    font-size: 12px;
`